<template>
  <div class="vmc-careers">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">Veritas Careers</h2>
          </div>
        </div>

        <div class="row justify-content-center mt-5">
          <div class="col-12">
            <!-- <div>
              <h4 class="font-weight-light">Apply Now</h4>
              <p class="font-weight-light">Fields marked with <span class="req-star">*</span> are required.</p>

              <form @submit.prevent="openPrivacyModal" novalidate>
                <div class="form-row-grid">
                  <div class="font-weight-light">
                    <label>Full Name <span class="req-star">*</span></label>
                    <input v-model.trim="form.name" type="text"
                      :class="['form-control', { 'input-error': errors.name }]" />
                    <span v-if="errors.name" class="err-msg">{{ errors.name }}</span>
                  </div>
                  <div class="font-weight-light">
                    <label>Address <span class="req-star">*</span></label>
                    <input v-model.trim="form.address" type="text"
                      :class="['form-control', { 'input-error': errors.address }]" />
                    <span v-if="errors.address" class="err-msg">{{ errors.address }}</span>
                  </div>
                </div>

                <div class="form-row-grid mt-3">
                  <div class="font-weight-light">
                    <label>Contact No. <span class="req-star">*</span></label>
                    <input v-model.trim="form.contactNo" type="text"
                      :class="['form-control', { 'input-error': errors.contactNo }]" />
                    <span v-if="errors.contactNo" class="err-msg">{{ errors.contactNo }}</span>
                  </div>
                  <div class="font-weight-light">
                    <label>Email Address <span class="req-star">*</span></label>
                    <input v-model.trim="form.email" type="email"
                      :class="['form-control', { 'input-error': errors.email }]" />
                    <span v-if="errors.email" class="err-msg">{{ errors.email }}</span>
                  </div>
                </div>
                <div class="form-row-grid mt-3">
                  <div class="font-weight-light">
                    <label>Viber No. <span class="opt-tag"></span></label>
                    <input v-model.trim="form.viberNo" type="text" class="form-control" />
                  </div>
                  <div class="font-weight-light">
                    <label>Messenger Name <span class="opt-tag"></span></label>
                    <input v-model.trim="form.messengerName" type="text" class="form-control" />
                  </div>
                </div>
                <div class="font-weight-light mt-3">
                  <label>Position to Apply For <span class="req-star">*</span></label>
                  <input v-model.trim="form.position" type="text"
                    :class="['form-control', { 'input-error': errors.position }]" />
                  <span v-if="errors.position" class="err-msg">{{ errors.position }}</span>
                </div>
                <div class="font-weight-light mt-3">
                  <label>Resume / CV <span class="req-star">*</span> <span class="opt-tag">(PDF only, max 10
                      MB)</span></label>
                  <div class="resume-row">
                    <label for="resume-upload" class="upload-btn">
                      <i class="material-symbols-outlined" style="font-size:18px;vertical-align:middle;">upload_file</i>
                      {{ form.resumeName || 'Choose PDF file' }}
                    </label>
                    <input id="resume-upload" type="file" accept="application/pdf" hidden @change="onResumeChange" />
                    <button v-if="form.resumeData" type="button" class="view-resume-btn" @click="viewResume">
                      <i class="material-symbols-outlined" style="font-size:18px;vertical-align:middle;">visibility</i>
                      View
                    </button>
                    <button v-if="form.resumeData" type="button" class="remove-resume-btn" @click="removeResume"
                      title="Remove">
                      &times;
                    </button>
                  </div>
                  <span v-if="errors.resume" class="err-msg">{{ errors.resume }}</span>
                </div>
                <div class="form-actions">
                  <button type="submit" class="vmc-bg-prime-5 border-0 rounded px-3 py-2 submit-btn" :disabled="submitting">
                    <span class="text-white" v-if="!submitting">Submit Application</span>
                    <span class="text-white" v-else>Sending&hellip;</span>
                  </button>
                </div>
              </form>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid vmc-py-big vmc-bg-dark-1">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 my-2" v-for="(item, index) in (cms.careerImages || [])" :key="index">
            <photo-gallery-modal v-if="item.image" :thumbnail="item.image" :images="[item.image]" />
          </div>
          <div class="col-12 text-center text-white" v-if="!cms.careerImages || cms.careerImages.length === 0">
            <p class="no-schedule-msg">No career available.</p>
          </div>
        </div>
      </div>
    </div>

    <transition name="modal-fade">
      <div v-if="showPdfModal" class="overlay overlay--locked">
        <div class="pdf-modal">
          <div class="pdf-modal-header">
            <span>{{ form.resumeName }}</span>
            <button class="modal-close-btn" @click="showPdfModal = false">&times;</button>
          </div>
          <iframe :src="form.resumeData" class="pdf-iframe" frameborder="0"></iframe>
        </div>
      </div>
    </transition>

    <transition name="modal-fade">
      <div v-if="showPrivacyModal" class="overlay overlay--locked">
        <div class="pn-wrap">

          <div class="pn-header">
            <h4 class="pn-title">Privacy Notice</h4>
          </div>

          <div class="pn-body" ref="pnBody" @scroll="checkScroll">
            <p>
              Veritas Maritime Corporation (VMC) is committed to protect and respect your personal data privacy.
              We are at the forefront of implementing and complying with the Data Privacy Act of 2012. This Privacy
              Notice concerns personal data submitted by any applicant and employed personnel during online or paper
              application process, personal data collected by VMC as part of the crewing / recruitment process,
              personal data collected by VMC as part of a previous employment process and personal data submitted
              in the Candidate and Employment Pool.
            </p>
            <p>
              Under the Data Privacy Act of 2012, individuals whose personal information is collected and processed
              are called data subjects. The company is duty bound to observe and respect your privacy rights,
              including your right to information, right to access, right to correct, right to remove, right to
              damages and right to data portability.
            </p>
            <p>
              VMC may collect Personal Information of a Data Subject only upon signing his or her consent and upon
              filing the application form. The Personal Information collected shall be processed solely in connection
              with the Data Subject's employment. All Personal information collected have been approved by the
              management of VMC and its Principal Employer under the specified reason.
            </p>
            <p>
              All personal data is being stored in a data based system called VERIPRO. A 3rd party company is
              contracted to manage and set security controls, to safeguard the rights of our personnel and seafarers.
              Access of 3rd party provider to Personal Information is protected by an OUTSOURCE CONTRACT AGREEMENT.
            </p>
            <p>
              Hardcopies are kept as well within the office 201 Files, for secured reference. In accordance with
              Philippines Data Privacy Act of 2012, we observe reasonable procedures to prevent unauthorized access
              to, and the misuse of your personal data.
            </p>
            <p>
              VMC transfers personal information to other 3rd party entities for the purpose of employment with
              the company, particularly to our Principal, Government Agencies and Port Agents as part of the
              employment process. As mandated by our National requirements, all OFW must submit specified personal
              information to different agencies like MARINA, OWWA and POEA to process employment contracts. Other
              arrangements on accommodations and other embarkation processing that will need selected personal
              information will be processed and complied with relevant data protection and legislation at all times.
            </p>
            <p>
              All personal data are securely stored, both hard and softcopy references, for the whole duration of
              employment, with a retention of 10 YEARS after separation or retirement with the Company. Unless
              requested with due instruction, deletion and disposal of your personal data will commence upon lapse
              of the said 10 Year period.
            </p>
            <p>If you have further questions or concerns, you may contact the following details:</p>

            <div class="row">
              <div class="col-sm-5 font-weight-bold d-flex justify-content-between">
                <span>Company Name/ PIC</span><span>:</span>
              </div>
              <div class="col-sm-7">Veritas Maritime Corporation</div>

              <div class="col-sm-5 font-weight-bold d-flex justify-content-between">
                <span>Telephone No.</span><span>:</span>
              </div>
              <div class="col-sm-7">
                <a href="tel:+63285243661">+632 85243661</a>
              </div>

              <div class="col-sm-5 font-weight-bold d-flex justify-content-between">
                <span>DPO Email Address</span><span>:</span>
              </div>
              <div class="col-sm-7">
                <p class="mb-0"><a href="mailto:dpo@veritas.com.ph">dpo@veritas.com.ph</a></p>
                <p><a href="mailto:peterfadul@veritas.com.ph">peterfadul@veritas.com.ph</a></p>
              </div>
            </div>

            <p class="mb-0">
              You may also visit or send official communication to the DPO's office address:
              <strong>
                <a href="https://goo.gl/maps/4csJjSj8sEnTX9Hv5" target="_blank">
                  15th Floor, March 2000 Tower 1973 Taft Avenue, Malate, Manila.
                </a>
              </strong>
            </p>
          </div>

          <div class="pn-footer">
            <button type="button" class="pn-accept-btn" @click="submitApplication" :disabled="submitting || !hasScrolledToBottom">
              <span v-if="!submitting" style="color: #fff;">I Accept</span>
              <span v-else style="color: #fff;">Sending&hellip;</span>
            </button>
            <button type="button" class="pn-cancel-link" @click="showPrivacyModal = false" :disabled="submitting">
              Cancel
            </button>
          </div>

        </div>
      </div>
    </transition>

    <transition name="modal-fade">
      <div v-if="showSuccessModal" class="overlay">
        <div class="success-modal">
          <i class="material-symbols-outlined success-icon">check_circle</i>
          <h5>Application Submitted!</h5>
          <p>Thank you, <strong>{{ submittedName }}</strong>. Your application has been sent successfully. We will get
            back to you as soon as possible.</p>
          <button class="btn vmc-btn-circle vmc-btn-secondary" @click="showSuccessModal = false">Close</button>
        </div>
      </div>
    </transition>

    <transition name="toast-fade">
      <div v-if="toastMsg" class="app-toast" :class="toastType">{{ toastMsg }}</div>
    </transition>

  </div>
</template>

<script>
import { cmsMixin } from '@/mixins/cmsMixin';
import PhotoGalleryModal from '@/components/programs/app-layout/PhotoGalleryModal';

export default {
  name: "CareersInVMC",
  mixins: [cmsMixin],
  components: {
    'photo-gallery-modal': PhotoGalleryModal
  },

  data() {
    return {
      form: {
        name: '', address: '', contactNo: '', email: '',
        viberNo: '', messengerName: '', position: '',
        resumeName: '', resumeData: ''
      },
      errors: {},
      showPdfModal: false,
      showPrivacyModal: false,
      showSuccessModal: false,
      submitting: false,
      submittedName: '',
      toastMsg: '',
      toastType: 'toast-success',
      toastTimer: null,
      hasScrolledToBottom: false 
    };
  },

  methods: {
    onResumeChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (file.type !== 'application/pdf') {
        this.showToast('Please upload a PDF file only.', 'toast-error');
        e.target.value = '';
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.showToast('File exceeds 10 MB limit.', 'toast-error');
        e.target.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = (ev) => {
        this.form.resumeData = ev.target.result;
        this.form.resumeName = file.name;
        if (this.errors.resume) this.$delete(this.errors, 'resume');
      };
      reader.readAsDataURL(file);
      e.target.value = '';
    },

    removeResume() {
      this.form.resumeData = '';
      this.form.resumeName = '';
    },

    viewResume() {
      if (!this.form.resumeData) return;
      this.showPdfModal = true;
    },

    validate() {
      const errs = {};
      if (!this.form.name) errs.name = 'Full name is required.';
      if (!this.form.address) errs.address = 'Address is required.';
      if (!this.form.contactNo) errs.contactNo = 'Contact number is required.';
      if (!this.form.email) {
        errs.email = 'Email address is required.';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        errs.email = 'Please enter a valid email address.';
      }
      if (!this.form.position) errs.position = 'Position is required.';
      if (!this.form.resumeData) errs.resume = 'Please attach your resume (PDF).';
      this.errors = errs;
      return Object.keys(errs).length === 0;
    },

    openPrivacyModal() {
      if (!this.validate()) {
        this.showToast('Please fill in all required fields.', 'toast-error');
        return;
      }
      this.hasScrolledToBottom = false; 
      this.showPrivacyModal = true;
      this.$nextTick(() => {
        this.checkScroll({ target: this.$refs.pnBody }); 
      });
    },

    checkScroll(e) {
      if (!e || !e.target) return;
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.hasScrolledToBottom = true;
      }
    },

    async submitApplication() {
      this.submitting = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/vmc/api/submit-application`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: this.form.name,
            address: this.form.address,
            contactNo: this.form.contactNo,
            email: this.form.email,
            viberNo: this.form.viberNo || '-',
            messengerName: this.form.messengerName || '-',
            position: this.form.position,
            resumeName: this.form.resumeName,
            resumeData: this.form.resumeData
          })
        });

        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.message || 'Server error');
        }

        this.submittedName = this.form.name;
        this.showPrivacyModal = false;
        this.showSuccessModal = true;
        this.resetForm();

      } catch (error) {
        this.showToast('Submission failed: ' + error.message, 'toast-error');
      } finally {
        this.submitting = false;
      }
    },

    resetForm() {
      this.form = {
        name: '', address: '', contactNo: '', email: '',
        viberNo: '', messengerName: '', position: '',
        resumeName: '', resumeData: ''
      };
      this.errors = {};
    },

    showToast(msg, type = 'toast-success') {
      clearTimeout(this.toastTimer);
      this.toastMsg = msg;
      this.toastType = type;
      this.toastTimer = setTimeout(() => { this.toastMsg = ''; }, 3500);
    },

    lockScroll() {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflowY = 'scroll';
    },
    
    unlockScroll() {
      const scrollY = Math.abs(parseInt(document.body.style.top || '0'));
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflowY = '';
      window.scrollTo(0, scrollY);
    }
  },

  watch: {
    showPrivacyModal(val) {
      val ? this.lockScroll() : this.unlockScroll();
    }
  }
};
</script>

<style scoped>
.application-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.09);
  padding: 36px 32px 28px;
  margin-top: 8px;
}

.form-section-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1a2a4a;
  margin-bottom: 4px;
}

.form-subtitle {
  color: #666;
  font-size: 0.88rem;
  margin-bottom: 22px;
}

.req-star {
  color: #e53935;
  font-weight: 700;
}

.opt-tag {
  color: #999;
  font-size: 0.8rem;
  font-weight: 400;
}

.form-row-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 18px;
}

@media (max-width: 576px) {
  .form-row-grid {
    grid-template-columns: 1fr;
  }
}

.field-wrap {
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
}

.field-wrap label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.app-input {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 9px 12px;
  font-size: 0.93rem;
  color: #222;
  outline: none;
  transition: border-color 0.2s;
}

.app-input:focus {
  border-color: #1a52a0;
  background: #fff;
}

.input-error {
  border-color: #e53935 !important;
}

.err-msg {
  color: #e53935;
  font-size: 0.78rem;
  margin-top: 3px;
}

.resume-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  background: #f0f4ff;
  border: 1.5px dashed #1a52a0;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 0.87rem;
  color: #1a52a0;
  font-weight: 600;
  transition: background 0.2s;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-btn:hover {
  background: #dde8ff;
}

.view-resume-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #1a52a0;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 0.87rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.view-resume-btn:hover {
  background: #133d80;
}

.remove-resume-btn {
  background: transparent;
  border: none;
  color: #e53935;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  font-weight: 700;
}

.form-actions {
  margin-top: 10px;
}

.submit-btn:hover:not(:disabled) {
  background-color: var(--vmc-primary-5);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.overlay--locked {
  pointer-events: all;
  touch-action: none;
  overscroll-behavior: contain;
}

.pdf-modal {
  background: #fff;
  border-radius: 10px;
  width: 95vw; 
  max-width: 1400px;
  height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.3);
}

.pdf-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600;
  font-size: 0.9rem;
  color: #333;
  background: #f5f7fa;
}

.pdf-iframe {
  flex: 1;
  width: 100%;
  border: none;
}

.modal-close-btn {
  background: transparent;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  color: #555;
  cursor: pointer;
  padding: 0 4px;
}

.pn-wrap {
  width: min(500px, 100%);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);
}

.pn-header {
  background: #1e3a5f;
  padding: 18px 24px;
  flex-shrink: 0;
}

.pn-title {
  margin: 0;
  color: #fff;
  font-size: 1.15rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.03em;
}

.pn-body {
  background: #fff;
  padding: 20px 20px 20px 20px;
  height: 500px;
  overflow-y: auto;
  font-size: 0.9rem;
  color: #212529;
  line-height: 1.7;
  flex-shrink: 0;
}

.pn-body p {
  margin-bottom: 14px;
}

.pn-body a {
  color: #1a52a0;
}

.pn-footer {
  background: #fff;
  padding: 14px 20px 18px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.pn-accept-btn {
  width: 100%;
  padding: 12px 0;
  background: #3dbfbf;
  color: #fff !important; 
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
  letter-spacing: 0.02em;
}

.pn-accept-btn:hover:not(:disabled) {
  background: #2da8a8;
}

.pn-accept-btn:disabled {
  background: #ccc;
  opacity: 0.6;
  cursor: not-allowed;
}

.pn-cancel-link {
  background: transparent;
  border: none;
  color: #888;
  font-size: 0.85rem;
  cursor: pointer;
  padding: 2px 8px;
  transition: color 0.2s;
}

.pn-cancel-link:hover:not(:disabled) {
  color: #444;
}

.pn-cancel-link:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.success-modal {
  background: #fff;
  border-radius: 12px;
  width: min(420px, 100%);
  padding: 36px 30px 28px;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
}

.success-icon {
  font-size: 56px;
  color: #2e7d32;
  display: block;
  margin-bottom: 12px;
}

.success-modal h5 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1a2a4a;
  margin-bottom: 8px;
}

.success-modal p {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 22px;
}

.app-toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 99999;
  padding: 12px 22px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  pointer-events: none;
}

.toast-success {
  background: #2e7d32;
}

.toast-error {
  background: #c62828;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
}

/* Modal Fade Transitions */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>